'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Pagination.scss');

var PageNumber = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(PageNumber, _PureComponent);

  function PageNumber() {
    (0, _classCallCheck3.default)(this, PageNumber);
    return (0, _possibleConstructorReturn3.default)(this, (PageNumber.__proto__ || (0, _getPrototypeOf2.default)(PageNumber)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageNumber, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          onClick = _props.onClick,
          pageNumber = _props.pageNumber;

      onClick(pageNumber);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          pageNumber = _props2.pageNumber,
          currentPage = _props2.currentPage;


      return _react2.default.createElement(
        'span',
        {
          className: (0, _bind2.default)(className, styles.pageItem, (0, _defineProperty3.default)({}, styles.active, pageNumber === currentPage)),
          key: pageNumber,
          onClick: this.onClick
        },
        pageNumber
      );
    }
  }]);
  return PageNumber;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  currentPage: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  pageNumber: _propTypes2.default.number
}, _class2.defaultProps = {
  onClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = PageNumber;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/PageNumber.js
// module id = 2036
// module chunks = 1